import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';

import { useGetPrizePost } from './hooks/useGetPrizePost';
import Text from '../../../../shared/Text';
import Button from '../../../../shared/Button';

import { DRAFT, LIVE, PICKED } from '../../utils/constants';

import { useScrollContext } from '../../contexts/ScrollContext.jsx';
import { scrollToRef } from '../../utils/scrollTo';

export const PrizeCta = ({ prize, posts }) => {
  const { prizeRef } = useScrollContext();
  const post = useGetPrizePost(posts);
  const { t } = useTranslation('prizes');

  let header = '';
  let subHeader = '';
  let buttonText = '';

  if (prize.status === PICKED) {
    header = t('prizesCta.postNotScheduled.header');
    subHeader = t('prizesCta.postNotScheduled.subHeader');
    buttonText = t('prizesCta.postNotScheduled.button');
  } else {
    header = t('prizesCta.winnerNotPicked.header');
    subHeader = t('prizesCta.winnerNotPicked.subHeader');
    buttonText = t('prizesCta.winnerNotPicked.button');
  }

  if (prize.status === DRAFT || prize.status === LIVE || post.status !== DRAFT)
    return null;

  return (
    <Container>
      <Content>
        <Header>{header}</Header>
        <SubHeader>{subHeader}</SubHeader>
      </Content>
      <Button
        variant="primary"
        mode="contained"
        width="220px"
        onClick={() => scrollToRef(prizeRef.current)}
      >
        <DownArrow />
        {buttonText}
      </Button>
    </Container>
  );
};

const Content = styled.div``;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 35px auto;
  width: 941px;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid ${themeGet('colors.primary.100')};
  background: linear-gradient(
      0deg,
      rgba(132, 153, 246, 0.2) 0%,
      rgba(132, 153, 246, 0.2) 100%
    ),
    #fff;
`;

const Header = styled(Text).attrs({ variant: 'h5' })`
  display: block;
  margin-bottom: 5px;
`;

const SubHeader = styled(Header).attrs({ variant: 'subtitle2' })``;

const DownArrow = styled.i.attrs({ className: 'fa-solid fa-arrow-down' })`
  margin-right: 5px;
`;
